import React from "react";
import { Crown } from "lucide-react";

/**
 * Small, reusable Prime membership badge. Use next to a name/email/order to
 * signal member status. Compact by default; pass `size="lg"` for the hero
 * dashboard chip.
 */
export default function PrimeBadge({ plan, size = "sm", className = "" }) {
  if (!plan) return null;
  const isPro = plan === "prime_pro";
  const label = isPro ? "Pro Plus" : "Pro";

  const scale =
    size === "lg"
      ? "h-8 px-3 text-xs"
      : size === "md"
        ? "h-7 px-2.5 text-[11px]"
        : "h-5 px-2 text-[10px]";

  const style = isPro
    ? {
        background:
          "linear-gradient(120deg, rgba(168,85,247,0.22) 0%, rgba(233,213,255,0.16) 100%)",
        color: "#a855f7",
        border: "1px solid rgba(168,85,247,0.5)",
      }
    : {
        background: "rgba(168,85,247,0.14)",
        color: "#a855f7",
        border: "1px solid rgba(168,85,247,0.42)",
      };

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full uppercase tracking-widest font-semibold ${scale} ${className}`}
      style={style}
      data-testid={`prime-badge-${plan}`}
    >
      <Crown size={size === "lg" ? 13 : 10} />
      {label}
    </span>
  );
}
